import React from 'react';
import { useIsPlayStore } from '../utils/playstore';

interface HideOnPlayStoreProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const HideOnPlayStore: React.FC<HideOnPlayStoreProps> = ({ children, fallback = null }) => {
  const isPlayStore = useIsPlayStore();

  if (isPlayStore) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
